module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/mic-466aab14ffe39e586102bd8ba18ef757.svg";